<template>
  <el-dialog
    :visible="value"
    width="520px"
    custom-class="sign-in-retry-dialog"
    :show-close="status === 'failed'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    @close="handleClose"
  >
    <div class="sign-in-retry-body">
      <!-- 状态1：验证失败 -->
      <template v-if="status === 'failed'">
        <div class="sign-in-retry-icon failed">
          <span class="icon-mark">!</span>
        </div>
        <div class="sign-in-retry-title">
          {{ $t("signInRetry.failedTitle") }}
        </div>
        <div class="sign-in-retry-desc">
          {{ $t("signInRetry.failedDesc") }}
        </div>
        <div class="sign-in-retry-divider"></div>
        <div class="sign-in-retry-subtitle">
          {{ $t("signInRetry.failedSubtitle") }}
        </div>
        <div class="sign-in-retry-desc">
          {{ $t("signInRetry.failedTip") }}
        </div>
        <div class="sign-in-retry-btns">
          <div class="sign-in-retry-btn edit" @click="handleEdit">
            {{ $t("signInRetry.editBtn") }}
          </div>
          <div
            class="sign-in-retry-btn retry"
            :class="{ disabled: countdown > 0 }"
            @click="handleRetry"
          >
            <template v-if="countdown > 0">
              {{ $t("signInRetry.tryAgain") }} {{ formatTime(countdown) }}
            </template>
            <template v-else>{{ $t("signInRetry.tryAgainNow") }}</template>
          </div>
        </div>
      </template>

      <!-- 状态2：重试中 -->
      <template v-else-if="status === 'retrying'">
        <div class="sign-in-retry-loading">
          <i class="el-icon-loading"></i>
        </div>
        <div class="sign-in-retry-title">
          {{ $t("signInRetry.retryingTitle") }}
        </div>
        <div class="sign-in-retry-desc">
          {{ $t("signInRetry.retryingDesc") }}
        </div>
        <div class="sign-in-retry-btns">
          <div class="sign-in-retry-btn retry disabled">
            <i class="el-icon-loading"></i>
            {{ $t("signInRetry.retryingBtn") }}
          </div>
        </div>
      </template>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SignInRetryDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    // failed: 验证失败冷却弹窗；retrying: 重试中弹窗
    status: {
      type: String,
      default: "failed",
      validator: (v) => ["failed", "retrying"].includes(v),
    },
    // 冷却时长（秒），默认 5 分钟
    cooldownSeconds: {
      type: Number,
      default: 60,
    },
  },
  data() {
    return {
      countdown: 0,
      timer: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val && this.status === "failed") {
          this.startCooldown();
        } else {
          this.clearTimer();
        }
      },
    },
    status(val) {
      if (val === "failed" && this.value) {
        this.startCooldown();
      } else {
        this.clearTimer();
      }
    },
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    startCooldown() {
      this.clearTimer();
      this.countdown = this.cooldownSeconds;
      this.timer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          this.clearTimer();
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.countdown = 0;
    },
    formatTime(seconds) {
      const m = Math.floor(seconds / 60)
        .toString()
        .padStart(2, "0");
      const s = (seconds % 60).toString().padStart(2, "0");
      return `${m}:${s}`;
    },
    handleEdit() {
      this.clearTimer();
      this.$emit("edit");
      this.$emit("input", false);
    },
    handleRetry() {
      if (this.countdown > 0) return;
      this.$emit("retry");
    },
    handleClose() {
      this.clearTimer();
      this.$emit("input", false);
    },
  },
};
</script>

<style>
.sign-in-retry-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

.sign-in-retry-dialog .el-dialog__header {
  display: none;
}

.sign-in-retry-dialog .el-dialog__body {
  color: #000927;
  padding: 0 !important;
}

.sign-in-retry-body {
  padding: 30px 26px 26px;
}

.sign-in-retry-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.sign-in-retry-icon.failed {
  background: #fff0f0;
}

.sign-in-retry-icon .icon-mark {
  color: #ff4d4f;
  font-size: 28px;
  font-weight: 700;
  font-family: Noto Sans, sans-serif;
}

.sign-in-retry-loading {
  text-align: center;
  margin-bottom: 20px;
}

.sign-in-retry-loading .el-icon-loading {
  font-size: 40px;
  color: #00eec3;
}

.sign-in-retry-title {
  font-family: Noto Sans, sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  margin-bottom: 8px;
}

.sign-in-retry-subtitle {
  font-family: Noto Sans, sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  margin-bottom: 4px;
}

.sign-in-retry-desc {
  color: #45484d;
  font-family: Noto Sans, sans-serif;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 8px;
}

.sign-in-retry-divider {
  height: 1px;
  background: #e1e3e6;
  margin: 20px 0;
}

.sign-in-retry-btns {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.sign-in-retry-btn {
  flex: 1;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 22px;
  font-family: Noto Sans, sans-serif;
  font-size: 15px;
  cursor: pointer;
  user-select: none;
  transition: opacity 0.2s;
  box-sizing: border-box;
}

.sign-in-retry-btn.edit {
  border: 2px solid #00eec3;
  color: #000927;
  background: #fff;
  font-weight: 400;
}

.sign-in-retry-btn.edit:hover {
  background: #f0fdf9;
}

.sign-in-retry-btn.retry {
  background: #00eec3;
  color: #000927;
  border-radius: 25px;
  font-weight: 700;
  box-shadow: 0 2px 6px rgb(8 145 120 / 50%);
}

.sign-in-retry-btn.retry.disabled {
  background: #d5d7db;
  color: #808080;
  cursor: not-allowed;
  box-shadow: none;
}

.sign-in-retry-btn.retry .el-icon-loading {
  margin-right: 6px;
}

@media screen and (max-width: 600px) {
  .sign-in-retry-dialog {
    margin-top: 15vh !important;
    max-width: 400px;
    width: calc(100% - 40px) !important;
  }

  .sign-in-retry-body {
    padding: 26px 22px 22px;
  }

  .sign-in-retry-title {
    font-size: 18px;
    line-height: 27px;
  }

  .sign-in-retry-btns {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignInRetryDialog.vue